import React, { useCallback, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { printables } from '../data/content';
export function ToolkitPreview() {
  const scrollerRef = useRef<HTMLUListElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const handleScroll = useCallback(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const card = scroller.firstElementChild as HTMLElement | null;
    if (!card) return;
    const step = card.offsetWidth + 16;
    setActiveIndex(Math.min(printables.length - 1, Math.round(scroller.scrollLeft / step)));
  }, []);
  const scrollByCard = (direction: 1 | -1) => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const card = scroller.firstElementChild as HTMLElement | null;
    if (!card) return;
    scroller.scrollBy({
      left: direction * (card.offsetWidth + 16),
      behavior: 'smooth'
    });
  };
  return <section className="bg-navy-deep py-11 text-ivory-light sm:py-16" aria-labelledby="toolkit-title" data-id="element-157" data-mp="2nkk8ivk0j8c6">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-158" data-mp="12wpedcaxb1r1">
        <div className="mx-auto max-w-xl text-center" data-id="element-159" data-mp="17vsf4kjvelt7">
          <p className="text-[10.5px] font-semibold uppercase tracking-[0.24em] text-gold-light sm:text-xs" data-id="element-160" data-mp="17yeompqbnbe2">
            And there&apos;s more…
          </p>
          <h2 id="toolkit-title" className="mt-2.5 font-display text-[22px] font-semibold uppercase leading-[1.1] tracking-tightish sm:text-4xl" data-id="element-161" data-mp="1gvyq9zs3j9p7">
            <span className="block text-[13px] font-semibold uppercase tracking-[0.14em] text-ivory/70 sm:text-lg" data-id="element-162" data-mp="p5asmxpmsmga">
              You&apos;ll also get the complete
            </span>
            Speech Therapy Practice Toolkit™
          </h2>
          <p className="mt-2.5 text-[12.5px] font-semibold uppercase tracking-[0.14em] text-sage sm:text-sm" data-id="element-163" data-mp="xzp7iz691uyv">
            40 ready-to-use clinical tools · Pediatric + adult
          </p>
          <p className="mx-auto mt-3 max-w-md text-[14px] leading-snug text-ivory/70 sm:text-base" data-id="element-164" data-mp="5gif0wz8b9y0">
            Practical printable resources to support your sessions — already organized and ready
            when you need them.
          </p>
        </div>

        <div className="relative mt-7 sm:mt-9" data-id="element-165" data-mp="1iiafa89oapiw">
          <ul ref={scrollerRef} onScroll={handleScroll} className="-mx-5 flex snap-x snap-mandatory gap-4 overflow-x-auto scroll-smooth px-5 pb-1 no-scrollbar sm:mx-0 sm:px-0" data-id="element-166" data-mp="1ii0qup4a0qfb">
            {printables.map(printable => <li key={printable.label} className="w-[66vw] max-w-[280px] shrink-0 snap-center sm:w-[calc((100%-2rem)/3)] sm:max-w-none" data-id="element-167" data-mp="kvl9rofrhusa">
                <img src={printable.image} alt={`${printable.label} — printable clinical tool`} className="aspect-[3/4] w-full rounded-lg bg-ivory-light object-cover object-top shadow-lift" loading="lazy" data-id="element-168" data-mp="usg3lu13b708" />
                <p className="mt-2.5 text-[11.5px] font-semibold uppercase leading-tight tracking-[0.08em] text-ivory/60 sm:text-xs" data-id="element-169" data-mp="2dr4aqt9mq1lg">
                  {printable.label}
                </p>
              </li>)}
          </ul>

          <div className="mt-4 flex items-center justify-center gap-3" data-id="element-170" data-mp="23urfhqyfrfol">
            <button type="button" onClick={() => scrollByCard(-1)} aria-label="Previous clinical tool" className="hidden h-9 w-9 items-center justify-center rounded-full border border-ivory/25 text-ivory/80 transition-colors duration-150 ease-out hover:bg-ivory/10 sm:flex" data-id="element-171" data-mp="28rrddel4tc4m">
              <ChevronLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-172" data-mp="2ms27qrlnh8uj" />
            </button>

            <div className="flex items-center gap-1.5" aria-hidden="true" data-id="element-173" data-mp="2rpluyh0bsvym">
              {printables.map((printable, index) => <span key={printable.label} className={`h-1.5 rounded-full transition-[width,background-color] duration-150 ease-out ${index === activeIndex ? 'w-5 bg-gold-light' : 'w-1.5 bg-ivory/25'}`} data-id="element-174" data-mp="3k7pso06wkuea" data-mpi={index} />)}
            </div>

            <button type="button" onClick={() => scrollByCard(1)} aria-label="Next clinical tool" className="hidden h-9 w-9 items-center justify-center rounded-full border border-ivory/25 text-ivory/80 transition-colors duration-150 ease-out hover:bg-ivory/10 sm:flex" data-id="element-175" data-mp="1mkf8gdsxb0bc">
              <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-176" data-mp="2abktd7dq0isi" />
            </button>
          </div>

          <p className="mt-2 text-center text-[10.5px] font-semibold uppercase tracking-[0.18em] text-ivory/40 sm:hidden" data-id="element-177" data-mp="25hzy3n3ii2x0">
            Swipe to explore
          </p>
        </div>

        <p className="mx-auto mt-7 max-w-md text-center text-[13.5px] leading-snug text-ivory/70 sm:text-base" data-id="element-178" data-mp="2y1onmo50r66u">
          40 practical clinical tools — organized, printable and ready when you need them.
        </p>
      </div>
    </section>;
}